/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { gql } from '@apollo/client';
import { Box, Col, Container } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import IframeResizer from 'iframe-resizer-react';
import { Helmet } from 'react-helmet';
import { jsx } from 'theme-ui';
import ContentRow from '../ContentRow';

const showNoteableWidget =
  process.env.GATSBY_TASTING_NOTE_PROVIDER === 'noteable.co';

export default function NoteableBanner({ product, ...rest }) {
  if (!showNoteableWidget) return null;
  return (
    <Box sx={{ backgroundColor: '#f2f2f2' }} {...rest}>
      <Helmet>
        <script src="https://noteable.co/get/bb/product-page-tasting/iframeResizer.min.js" />
      </Helmet>
      <Container>
        <ContentRow>
          <Col flex>
            <IframeResizer
              sx={{ width: 1, minWidth: '100%', border: 0 }}
              src={`https://noteable.co/get/bb/product-page-tasting?product=${product.productId}&event=${product.collectionId}&client=${product.partnerId}&producer=${product.product?.producer?.producerId}`}
              title="Add a tasting note with Noteable"
            />
          </Col>
        </ContentRow>
      </Container>
    </Box>
  );
}

export const fragment = graphql`
  fragment NoteableBanner on Bottlebooks_RegisteredProduct {
    productId
    collectionId
    partnerId
    product {
      producer {
        producerId
      }
    }
  }
`;

NoteableBanner.fragment = gql`
  fragment NoteableBanner on RegisteredProduct {
    productId
    collectionId
    partnerId
    product {
      producer {
        producerId
      }
    }
  }
`;
